import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
import _inheritsLoose from "@babel/runtime/helpers/inheritsLoose";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React, { Component } from 'react';
import { number } from 'prop-types';
import Icon from 'react-icon-base';

var BagIcon =
/*#__PURE__*/
function (_Component) {
  _inheritsLoose(BagIcon, _Component);

  function BagIcon() {
    return _Component.apply(this, arguments) || this;
  }

  var _proto = BagIcon.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        quantity = _this$props.quantity,
        props = _objectWithoutPropertiesLoose(_this$props, ["quantity"]);

    var textProps = quantity > 99 ? {
      fontSize: '8px',
      y: '20'
    } : {
      fontSize: '12px',
      y: '20.5'
    };
    return React.createElement(Icon, _extends({
      viewBox: "0 0 23 26"
    }, props), React.createElement("g", {
      xmlns: "http://www.w3.org/2000/svg"
    }, React.createElement("path", {
      d: "M18.687 26c2.244 0 4.063-1.819 4.063-4.063V6.5h-4.875c0-3.584-2.916-6.5-6.5-6.5s-6.5 2.916-6.5 6.5H0v15.437C0 24.181 1.819 26 4.062 26h14.625zM16.25 6.5H6.5c0-2.688 2.187-4.875 4.875-4.875S16.25 3.812 16.25 6.5zm2.437 17.875H4.062c-1.344 0-2.437-1.094-2.437-2.438V8.125h3.25v2.437c0 .45.364.813.812.813.45 0 .813-.364.813-.813V8.125h9.75v2.437c0 .45.364.813.812.813.45 0 .813-.364.813-.813V8.125h3.25v13.812c0 1.344-1.094 2.438-2.438 2.438z",
      fill: "currentColor",
      fillRule: "evenodd"
    }), React.createElement("text", _extends({
      x: "11.5",
      fontWeight: "bold",
      strokeWidth: "0",
      fill: "currentColor",
      textAnchor: "middle"
    }, textProps), quantity)));
  };

  return BagIcon;
}(Component);

_defineProperty(BagIcon, "propTypes", {
  /**
   * Number of items to show. Could be one or two digits
   */
  quantity: number,

  /**
   * Icon size
   */
  size: number
});

export { BagIcon as default };